<template>
    <div class="menu-page">
        <div class="menu-header" @click="toPage('/member/vip/basic')">
            <img v-if="orginizInfo.morglogo" :src="orginizInfo.morglogo" class="header-avatar"/>
            <img v-else class="header-avatar" src="../../../assets/img/avatar_member.jpg"/>
<!--            <el-popover
                trigger="click"
                placement="bottom"
                width="160">
                <div class="flex flex-direction">
                    <div v-for="menu in options" :key="menu.value">
                        <el-popover
                            :disabled="!menu.children"
                            trigger="hover"
                            placement="right">
                            <div class="flex flex-direction">
                                <div v-for="item in menu.children" :key="item.id">
                                    <div class="menu-title flex align-center justify-between" @click="changeUser(item)">
                                       <div class="flex align-center">
                                           {{item.orgName}}
                                           <el-tag v-if="user.mid === item.user_id" class="margin-left-xs" type="success" size="mini">当前</el-tag>
                                       </div>
                                        <i class="el-icon-arrow-right margin-left-sm"></i></div>
                                </div>
                            </div>
                            <div slot="reference"  class="menu-title flex align-center justify-between">
                                {{menu.label}}<i class="el-icon-arrow-right"></i></div>
                        </el-popover>

                    </div>
                </div>
                <div slot="reference" class="header-name" >{{ userInfo.user_type === 1 ? userInfo.company : userInfo.name }}<i class="el-icon-arrow-down"></i></div>
            </el-popover>-->
          <div slot="reference" class="header-name" >{{ userInfo.user_type === 1 ? userInfo.company : userInfo.name }}</div>
          <div class="header-tag">{{ userInfo.rank_name }}</div>
          <router-link class="header-integral" to="/member/vip/basic">积分：{{ userInfo.integral }}分</router-link>
        </div>
        <div class="vip-time">到期时间:{{ userInfo.end_time }}
            <router-link class="pay" to="/member/payment">立即续费</router-link>
        </div>
        <div class="menus">
            <div v-for="(item,index) in menus" :key="index" class="flex flex-direction">
                <div :class="{ active: navIndex[0]  == item.value}"
                             @click="toPage(`${item.page}`)"
                             class="mune-item">
                    <i :class="[{active: navIndex[0]  == item.value},item.icon]" class="iconfont"></i>
                    <div :class="{ active: navIndex[0]  == item.value}" class="title">{{ item.label }}</div>
                    <i class="expand" :class="[{active: navIndex[0]  == item.value},item.expand ? 'el-icon-arrow-down': 'el-icon-arrow-up']"
                       @click.stop="expand(index)" v-if="item.childs && item.childs.length"></i>
                </div>
                <div v-if="item.childs && item.expand" class="flex flex-direction">
                    <router-link v-for="(child,position) in item.childs" :key="position"
                                 :class="{ active: navIndex[1]  == child.value && navIndex[0]  == item.value}"
                                 :to="child.page" class="menu-child">
                        {{ child.label }}
                    </router-link>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import {memberMenus} from '@/utils/const'
import {isLastDate, zhDate,getUser} from '@/utils/utils'
import {getOrganizInfo, userInfo, userNoticeRemindState,getOrgListByUserPhone,userLoginByMidAndUserId} from '@/api/member'

export default {
    name: "MenuMemberModular",
    data() {
        return {
            menus: JSON.parse(JSON.stringify(memberMenus)),
            users: [],
            options: [],
            // options: [{
            //     value: 1,
            //     label: '切换账号',
            //     children:[]
            // }],
            userInfo: '',
            orginizInfo: '',
        };
    },
    props: {
        navIndex: {},
        menu: {
            type: Number,
            default: 0
        },
    },
    computed: {
        user() {
            return getUser()
        }
    },
    created() {
        this.init()
        this.getOrganizInfo()
        this.getOrgListByUserPhone()
        this.menus.map((item,index) => {
            item.expand = false
            item.position = index
            item._position = index
        })
    },
    methods: {
        setExpand() {
            this.menus.map(item => {
                item._position = item.value === this.navIndex[0] ? -1 : item.position
                item.expand = item.value === this.navIndex[0]
            })
            // this.menus = this.menus.sort((a,b)=>{
            //     return a._position - b._position
            // })
        },
        expand(index) {
            this.menus[index].expand = !this.menus[index].expand
            this.$forceUpdate()
        },
        toPage(path) {
            this.$router.push(path)
        },
        async init() {
            let _data = await userInfo()
            if (_data.status === 200) {
                let time = _data.data.end_time * 1000
                _data.data.end_time = zhDate(time)
                this.userInfo = _data.data
                if (isLastDate(time, 30)) {
                    this.$confirm(
                        `你的会员${isLastDate(time, 0) ?'已':'即将'}到期，请${isLastDate(time, 0) ?'':'提前'}进行续费`,
                        '续费提醒', {
                            confirmButtonText: '去续费',
                            type: 'warning',
                            closeOnClickModal: false,
                            closeOnPressEscape: false,
                        }
                    ).then(() => {
                        this.$router.replace('/member/payment')
                    })
                }
            }
            _data = await userNoticeRemindState()
            if (_data.status === 200) {
                if (_data.data > 0) {
                    this.$confirm(
                        '你有新的通知，是否立即查看',
                        '通知提醒', {
                            confirmButtonText: '去查看',
                            type: 'warning',
                            closeOnClickModal: false,
                            closeOnPressEscape: false,
                        }
                    ).then(() => {
                        this.$router.replace('/member/notice')
                    })
                }
            }
        },
        async getOrganizInfo() {
            let _data = await getOrganizInfo()
            if (_data.status === 200) {
                this.orginizInfo = _data.data
            }

        },
        async getOrgListByUserPhone() {
            let _data = await getOrgListByUserPhone(this.user.mid,this.user.phone)
            if (_data.status === 200) {
                this.options[0].children = _data.data
            }

        },
        async changeUser(item) {
            if (item.user_id === this.user.mid) return
            let _data = await userLoginByMidAndUserId(item.user_id)
            if (_data.status === 200) {
                _data.data.isBranch = false
                this.$store.state.emofUserTokenSafer =  _data.data.emofUserTokenSafer
                this.$store.state.user =  _data.data
                await window.localStorage.setItem('user', JSON.stringify( _data.data))
                // window.location.reload()
                this.$router.go(0)
                this.$message.success('切换成功')
            }

        }
    },
    watch: {
        navIndex() {
            this.setExpand()
        }
    },
};
</script>

<style lang="scss" scoped>
.menu-title{
    color: #333333;
    height: 40px;
    font-size: 14px;
    padding: 0 11px;
    line-height: 40px;
    width: 100%;
    cursor: pointer;
    &:hover{
        background: #0a224055;
        border-radius: 5px;
    }
}

.menu-page {
    display: flex;
    flex-direction: column;
    width: 170px;
    flex-shrink: 0;

    .menu-header {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background-color: #0a2240;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        padding: 26px 26px 15px;
        cursor: pointer;

        .header-avatar {
            width: 74px;
            height: 74px;
            border-radius: 74px;
        }

        .header-name {
            text-align: center;
            font-size: 14px;
            line-height: 18px;
            color: #ffffff;
            margin-top: 12px;
            cursor: pointer;
        }

        .header-tag {
            height: 25px;
            line-height: 25px;
            background-color: #0a2240;
            border-radius: 13px;
            border: solid 1px #ff9600;
            font-size: 12px;
            color: #ff9600;
            padding: 0 12px;
            margin-top: 20px;
        }
        .header-integral {
            font-size: 12px;
            color: #ff9600;
            margin-top: 10px;
        }

    }

    .vip-time {
        width: 100%;
        height: 32px;
        background-color: #0a2240dd;
        font-size: 10px;
        color: #ffffff;
        box-shadow: 0 6px 16px 1px rgba(10, 34, 64, 0.47);
        border-bottom-right-radius: 10px;
        border-bottom-left-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;

        .pay {
            font-size: 12px;
            line-height: 15px;
            color: #ff9600;
            text-decoration: underline;
        }
    }

    .menus {
        width: 100%;
        flex: 1;
        background-color: #0a2240;
        box-shadow: 0 6px 16px 1px rgba(10, 34, 64, 0.47);
        border-radius: 10px;
        margin-top: 10px;

        .mune-item {
            height: 100px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            background: none;
            position: relative;
            cursor: pointer;
            .expand {
                position: absolute;
                right: 10px;
                top: 50%;
                transform: translateY(-50%);
                font-size: 20px;
                color: #ffffff;

                &.active {
                    color: #ff9600;

                }
            }
            &:after {
                position: absolute;
                right: 0;
                bottom: 0;
                width: 100%;
                height: 1px;
                background: #ffffff33;
                transform: translateY(-50%);
                content: '';
            }

            &.active {
                background: #233953;
                border-radius: 10px;

                &:before {
                    position: absolute;
                    right: -8px;
                    border-top: 8px solid transparent;
                    border-left: 8px solid #233953;
                    border-bottom: 8px solid transparent;
                    top: 50%;
                    transform: translateY(-50%);
                    content: '';
                }
            }

            .title {
                font-size: 18px;
                color: #ffffff;
                margin-top: 10px;

                &.active {
                    color: #ff9600;

                }
            }

            i {
                font-size: 30px;
                color: #ffffff;

                &.active {
                    color: #ff9600;

                }
            }
        }

        .menu-child {
            width: 100%;
            height: 58px;
            font-size: 18px;
            line-height: 58px;
            color: #ffffff;
            padding-left: 60px;
            background: #233953;
            border-bottom: 1px solid #ffffff33;

            &.active {
                position: relative;
                color: #ffa11a;

                &:before {
                    position: absolute;
                    width: 3px;
                    height: 17px;
                    background-color: #ff9600;
                    border-radius: 2px;
                    left: 48px;
                    top: 50%;
                    transform: translateY(-50%);
                    content: '';
                }
            }
        }
    }

}
</style>
